import { render, staticRenderFns } from "./jumpOverMsgBox.vue?vue&type=template&id=6232b6a0&scoped=true&"
import script from "./jumpOverMsgBox.vue?vue&type=script&lang=js&"
export * from "./jumpOverMsgBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6232b6a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
